import { Modal } from "react-bootstrap";
import FintooBackButton from "../HTML/FintooBackButton";
import FintooCheckbox from "../FintooCheckbox/FintooCheckbox";
import React from "react";
import { indianRupeeFormat, fetchEncryptData } from "../../common_utilities";
import Table from "react-bootstrap/Table";
import style from "./otpmodal.module.css";
import Swal from "sweetalert2";

const StopSipSelectionModal = ({ detailedMfPotfolio, setDetailedMfPotfolio }) => {

  const toggleTrnxCheckbox = (v) => {
    console.log('v', v);
    setDetailedMfPotfolio(prev => ({
      ...prev,
      sip_stp_swp_data: {
        ...prev.sip_stp_swp_data,
        sip_list: prev.sip_stp_swp_data.sip_list.map(x => ({
          ...x,
          checked: x.transaction_id === v.transaction_id ? !(Boolean(x.checked)) : x.checked
        }))
      }
    }));
  }


  const toggleeditTrnxCheckbox = (v) => {
    setDetailedMfPotfolio(prev => ({
      ...prev,
      sip_stp_swp_data: {
        ...prev.sip_stp_swp_data,
        sip_list: prev.sip_stp_swp_data.sip_list.map(x => ({
          ...x,
          editsipchecked: x.transaction_id === v.transaction_id ? !(Boolean(x.editsipchecked)) : x.editsipchecked
        }))
      }
    }));
  }
  // console.log('detailedMfPotfolio29', detailedMfPotfolio);

  const checkMaintenanceStatus = async (type) => {
    try {
      const maintenancePopup = await fetchEncryptData({
        data: {},
        method: "post",
        url: process.env.REACT_APP_DMF_BASE_URL + "api/common/getmaintenancedetails",
      }).then((r) => {
        return r.data.find((item) => item.key === type && item.active === "1");
      });

      return maintenancePopup;
    } catch (e) {
      console.error("Error fetching maintenance status:", e);
      throw e; // Rethrow to indicate failure
    }
  };

  return (
    <>
      <Table responsive className="trx-tbl8">
        <thead>
          <tr>
            <th>SIP Amount</th>
            <th>SIP Date</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {(detailedMfPotfolio?.fund_list ?? []).map((v) => (<React.Fragment key={'k-' + v.transaction_id}>
            <tr>
              <td>{indianRupeeFormat(v.active_sip_amount)}</td>
              <td>{v.cart_sip_start_date}</td>
              <td>{v.cart_sip_start_date}</td>
              <td>{v.sip_start_date}</td>
              <td scope="row" data-label="">
                <div className={`${style.SIPButtons}`}>
                  <div className="d-md-block d-none">
                    <button onClick={() => {
                    toggleeditTrnxCheckbox(v)
                    }}>Edit SIP</button>
                    <button onClick={() => {

                    }}>Skip SIP</button>
                    <button 
                    // onClick={() => {
                    //   toggleTrnxCheckbox(v);
                    // }}
                    onClick={async () => {
                      toggleTrnxCheckbox(v);
                      // const maintenancePopup = await checkMaintenanceStatus('maintenance');
                      // if (maintenancePopup) {
                      //   Swal.fire(maintenancePopup.value);
                      // } else {
                      //   toggleTrnxCheckbox(v);
                      // }
                    }}
                    >Stop SIP</button>
                  </div>
                  <div className="d-md-none d-block w-100">
                    <center>
                      <button onClick={() => {

                      }}>Manage SIP</button>
                    </center>
                  </div>
                </div>
              </td>
            </tr>
          </React.Fragment>))}

        </tbody>
      </Table>
    </>
  );
};
export default StopSipSelectionModal;
